unit uDriverChoice2;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Buttons, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.WebCtrls, uGlobal,
  uHTTPHelper, WEBLib.JSON, WEBLib.JsonData, WEBLib.REST;

type
  TfrmDriverChoice2 = class(TForm)
    pnTop: TPanel;
    WebLabel1: TLabel;
    btClose: TSpeedButton;
    divDriver: THTMLDiv;
    procedure WebFormCreate(Sender: TObject);
    procedure btCloseClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    ChoosenID: integer;
    ChoosenName: string;
    RaceID: integer;
    Sprint: integer;
    procedure ChooseDriverClick(driver_id: integer; givenname, familyname: string);
    [async]
    procedure GetDrivers; async;
  protected procedure LoadDFMValues; override; end;

var
  frmDriverChoice2: TfrmDriverChoice2;
  tabDriver: JSValue;

implementation

{$R *.dfm}

procedure TfrmDriverChoice2.btCloseClick(Sender: TObject);
begin
  ChoosenID := -1;
  ChoosenName := '';
  Close;
end;

procedure TfrmDriverChoice2.ChooseDriverClick(driver_id: integer; givenname, familyname: string);
begin
  ChoosenID := driver_id;
  ChoosenName := givenname + ' ' + familyname;
  Close;
end;

procedure TfrmDriverChoice2.GetDrivers;
var
  status: integer;
  joReq, jo: TJSONObject;
  da: TJSArray;
begin
  //Fahrerauswahl
  joReq := TJSONObject.Create;
  joReq.AddPair('race_id', RaceID);
  joReq.AddPair('sprint', Sprint);

  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/qualiresult/', httpPOST, joReq.ToJSON, jo));

  if (Status = HTTP_OK) then
  begin
    da := TJSArray(TJSJSON.parseObject(jo.ToJSON));
    asm
      this.tabDriver.replaceData(da);
    end;
  end;

end;

procedure TfrmDriverChoice2.WebFormCreate(Sender: TObject);
var
  DataArray: TJSArray;
begin
  // Define an empty table, attach it to the TWebHTML component that has an ElementID of 'tabExample'
  //{field: "POS",    title: "Pos.", width:    100, resizable: false, vertAlign: "middle", hozAlign: "center"},
  asm
    this.tabDriver = new Tabulator("#tabDriver", {
      layout: "fitColumns",
      rowHeight: 50,

 	    columns: [
        {field: "driver_id",   title: "ID", minWidth: 50, visible: false},
        {field: "position",   title: "Pos.", width: 80, vertAlign: "middle", hozAlign: "center"},
        {field: "givenname",   title: "Fahrer", width: 130, vertAlign: "middle", headerSort: false},
        {field: "familyname",   title: "", vertAlign: "middle"}
      ]
    });

    var DelphiRowClick = this.ChooseDriverClick.bind(this);
    this.tabDriver.on("rowClick", function(e,row){
      DelphiRowClick(row.getCell(this.getColumn('driver_id')).getValue(), row.getCell(this.getColumn('givenname')).getValue(), row.getCell(this.getColumn('familyname')).getValue());
    });


  end;

//  GetDrivers;
end;

procedure TfrmDriverChoice2.WebFormShow(Sender: TObject);
begin
  GetDrivers;
end;

procedure TfrmDriverChoice2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnTop := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  btClose := TSpeedButton.Create(Self);
  divDriver := THTMLDiv.Create('tabDriver');

  pnTop.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  btClose.BeforeLoadDFMValues;
  divDriver.BeforeLoadDFMValues;
  try
    Name := 'frmDriverChoice2';
    Width := 272;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnTop.SetParentComponent(Self);
    pnTop.Name := 'pnTop';
    pnTop.Left := 0;
    pnTop.Top := 0;
    pnTop.Width := 272;
    pnTop.Height := 51;
    pnTop.Align := alTop;
    pnTop.ChildOrder := 4;
    pnTop.Color := 15890688;
    pnTop.TabOrder := 0;
    WebLabel1.SetParentComponent(pnTop);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 12;
    WebLabel1.Top := 17;
    WebLabel1.Width := 194;
    WebLabel1.Height := 19;
    WebLabel1.Caption := 'Wahl aus Startaufstellung';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWhite;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Arial';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    btClose.SetParentComponent(Self);
    btClose.Name := 'btClose';
    btClose.Left := 224;
    btClose.Top := 3;
    btClose.Width := 48;
    btClose.Height := 48;
    btClose.Anchors := [akTop,akRight];
    btClose.Color := 15890688;
    btClose.ElementClassName := 'btn';
    btClose.HeightPercent := 100.000000000000000000;
    btClose.MaterialGlyph := 'close';
    btClose.MaterialGlyphColor := clWhite;
    btClose.MaterialGlyphSize := 32;
    btClose.TabOrder := 1;
    btClose.WidthPercent := 100.000000000000000000;
    SetEvent(btClose, Self, 'OnClick', 'btCloseClick');
    divDriver.SetParentComponent(Self);
    divDriver.Name := 'divDriver';
    divDriver.Left := 0;
    divDriver.Top := 51;
    divDriver.Width := 272;
    divDriver.Height := 421;
    divDriver.Anchors := [akLeft,akTop,akRight,akBottom];
    divDriver.ChildOrder := 2;
    divDriver.Role := '';
  finally
    pnTop.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    btClose.AfterLoadDFMValues;
    divDriver.AfterLoadDFMValues;
  end;
end;

end.